import React, {useState} from "react";
import {Select as AntdSelect} from "antd";
import {debounce} from "lodash";
//local
import Select from "components/selects/Select";
import {SignContractCompanyInfoTag} from "./SignContractCompanyInfoTag";

const {Option} = AntdSelect;
export const SignContractMemberSelect = ({add, search}) => {
  const [data, setData] = useState([]);

  const handleSearch = debounce(async (value) => {
    const name = value?.trim();
    name.length && setData(await search(name));
  }, 400);

  const handleChange = (val) => add(data.find((item) => item.id === val));
  const stopPropagation = (e) => e.code === "Enter" && e.stopPropagation();

  return (
    <Select
      shadow
      large
      fullWidth
      addDropdownClass="recipients-tab_custom-select-dropdown"
      addClass="full-width"
      showSearch={!!search}
      onInputKeyDown={stopPropagation}
      placeholder="TYPE_TO_ADD_COMPANY"
      filterOption={false}
      onSearch={handleSearch}
      onChange={handleChange}
      optionLabelProp="label"
      notFoundContent="FIRST_SETUP_SELECT_NO_DATA"
    >
      {data.map((item) => (
        <Option
          key={item.id}
          value={item.id}
          label={item.name}
          className="recipients-tab_custom-select-dropdown_row"
        >
          <span className="row__organization">{item.name}</span>
          <div className="row__statuses">
            <SignContractCompanyInfoTag
              number={item.Company?.companyNumber}
              name={item.Company?.companyName}
              bordered
            />
          </div>
        </Option>
      ))}
    </Select>
  );
};
